import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col-lg-8 offset-lg-2" };
const _hoisted_3 = { class: "productDescriptionWrapper" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    const _component_product_description_entry = _resolveComponent("product-description-entry");
    const _component_product_description_entry_details = _resolveComponent("product-description-entry-details");
    const _component_product_description_entry_bewertungen = _resolveComponent("product-description-entry-bewertungen");
    const _component_product_description_entry_garantie = _resolveComponent("product-description-entry-garantie");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_product_description_entry, {
                    title: "Beschreibung",
                    content: (_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.parsedDescription
                }, null, 8, ["content"]),
                _createVNode(_component_product_description_entry_details),
                false
                    ? (_openBlock(), _createBlock(_component_product_description_entry_bewertungen, { key: 0 }))
                    : _createCommentVNode("", true),
                (((_b = _ctx.currentProduct) === null || _b === void 0 ? void 0 : _b.hasExtendedWarrantyMonth) === 36)
                    ? (_openBlock(), _createBlock(_component_product_description_entry_garantie, { key: 1 }))
                    : _createCommentVNode("", true)
            ])
        ])
    ]));
}
